import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import store from '@/store/index.js';

import Quiz from '@/views/Quiz';
import Result from '@/views/Result';
import Collection from '@/views/Collection';

Vue.use(VueRouter)

const routes = [
  {
    path: '/quiz',
    name: 'Quiz',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/Quiz.vue' )
    // component: Quiz,
  },
  {
    path: '/result',
    name: 'Result',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/Result.vue' )
    // component: Result,
  },
  {
    path: '/collection',
    name: 'Collection',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/Collection.vue' )
    // component: Collection,
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/:id?',
    name: 'Home',
    component: Home
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

let prevRoute;

router.beforeEach((to, from, next) => {
  // console.log('router beforeEach');
  //
  // console.log(to);

  /**
   * Check to see if the route is valid when user has not done the quiz yet.
   * If it's /result or /collection, we want to redirect them to home.
   */
  // if( store.getters['user/getQuizResult'] === null ) {
  //   if( to.path.match(/result/) !== null  || to.path.match(/collection/) !== null ) {
  //     router.replace({path:'/'});
  //
  //   } else {
  //     next();
  //   }
  // } else {
  //   next();
  // }
  next();
})

export default router
